import {
    NEW_ANIMAL_CATEGORIA_CADASTRO_SUCCESS,
    CANCEL_ANIMAL_CATEGORIA_CADASTRO_RAPIDO_SUCCESS,
    TABLE_ANIMAL_CATEGORIA_CADASTRO_PENDING,
    TABLE_ANIMAL_CATEGORIA_CADASTRO_SUCCESS,
    TABLE_ANIMAL_CATEGORIA_CADASTRO_FAILURE,
    LIST_ANIMAL_CATEGORIA_CADASTRO_PENDING,
    LIST_ANIMAL_CATEGORIA_CADASTRO_SUCCESS,
    LIST_ANIMAL_CATEGORIA_CADASTRO_FAILURE,
    FIND_ANIMAL_CATEGORIA_CADASTRO_PENDING,
    FIND_ANIMAL_CATEGORIA_CADASTRO_SUCCESS,
    FIND_ANIMAL_CATEGORIA_CADASTRO_FAILURE,
    DELETE_ANIMAL_CATEGORIA_CADASTRO_PENDING,
    DELETE_ANIMAL_CATEGORIA_CADASTRO_SUCCESS,
    DELETE_ANIMAL_CATEGORIA_CADASTRO_FAILURE,
    CREATE_ANIMAL_CATEGORIA_CADASTRO_PENDING,
    CREATE_ANIMAL_CATEGORIA_CADASTRO_SUCCESS,
    CREATE_ANIMAL_CATEGORIA_CADASTRO_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function animalCategoriaCadastroReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_ANIMAL_CATEGORIA_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: action.isCadastroRapido ?? false,
            }
        case LIST_ANIMAL_CATEGORIA_CADASTRO_PENDING:
        case FIND_ANIMAL_CATEGORIA_CADASTRO_PENDING:
        case DELETE_ANIMAL_CATEGORIA_CADASTRO_PENDING:
        case CREATE_ANIMAL_CATEGORIA_CADASTRO_PENDING:
        case TABLE_ANIMAL_CATEGORIA_CADASTRO_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CANCEL_ANIMAL_CATEGORIA_CADASTRO_RAPIDO_SUCCESS:
            return {
                ...state,
                isCadastroRapido: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_ANIMAL_CATEGORIA_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_ANIMAL_CATEGORIA_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_ANIMAL_CATEGORIA_CADASTRO_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_ANIMAL_CATEGORIA_CADASTRO_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_ANIMAL_CATEGORIA_CADASTRO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_ANIMAL_CATEGORIA_CADASTRO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_ANIMAL_CATEGORIA_CADASTRO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_ANIMAL_CATEGORIA_CADASTRO_SUCCESS:
        case CREATE_ANIMAL_CATEGORIA_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        case DELETE_ANIMAL_CATEGORIA_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { animalCategoriaCadastroReducer };